import { createUseStyles } from 'react-jss';

const speedAnimation = (isEnter, speed) => {
  const curveEntrance = 'cubic-bezier(0, 0, 0, 1)';
  const curveEase = 'cubic-bezier(0.2, 0, 0.1, 1)';

  const bezier = isEnter ? curveEntrance : curveEase;
  const transform = `transform ${speed}ms ${bezier}`;

  const opacity = `opacity ${speed / (isEnter ? 5 : 2)}ms linear ${
    speed / (isEnter ? 10 : 2)
  }ms`;

  return `${transform}, ${opacity}`;
};

const directionAnimation = (direction, distance, isZero) => {
  return {
    up: `translateY(${isZero ? 0 : distance}%)`,
    down: `translateY(-${isZero ? 0 : distance}%)`,
    left: `translateX(${isZero ? 0 : distance}%)`,
    right: `translateX(-${isZero ? 0 : distance}%)`,
  }[direction];
};

const useStyles = createUseStyles({
  wdsSlide: ({ slideSpeed, direction, slideDistance }) => ({
    '&$enter': {
      transform: directionAnimation(direction, slideDistance, false),
    },
    '&$enterActive': {
      transition: speedAnimation(true, slideSpeed),
      transform: directionAnimation(direction, slideDistance, true),
    },
    '&$exit': {
      transform: directionAnimation(direction, slideDistance, true),
    },
    '&$exitActive': {
      transition: speedAnimation(false, slideSpeed),
      transform: directionAnimation(direction, slideDistance, false),
    },
  }),
  enter: { opacity: '0' },
  enterActive: { opacity: '1' },
  exit: { opacity: '1' },
  exitActive: { opacity: '0' },
});

export default useStyles;
